// Why a quote was lost. Picked in the "Mark as Lost" dialog and stored on the quote as
// `lostReason` ({ category, text, by, at }) and on its 'marked-lost' log entry. The key is what
// gets stored; the label is only for display, so it can be reworded without touching data.
const LOST_REASONS = [
    { key: 'transit-time', label: 'Transit time too long' },
    { key: 'carrier', label: 'Prefer not to work with this carrier' },
    { key: 'price', label: 'Offer is too expensive' },
    { key: 'other', label: 'Other' },
];

const LOST_REASON_KEYS = LOST_REASONS.map(r => r.key);

function lostReasonCategoryLabel(category) {
    return LOST_REASONS.find(r => r.key === category)?.label || null;
}

// One line for a reason, e.g. 'Offer is too expensive' or 'Other: "Customer went with DHL"'.
function lostReasonText(lostReason) {
    if (!lostReason?.category) return null;
    const label = lostReasonCategoryLabel(lostReason.category);
    if (lostReason.category === 'other' && lostReason.text) return `${label}: "${lostReason.text}"`;
    return label;
}

export { LOST_REASONS, LOST_REASON_KEYS, lostReasonCategoryLabel, lostReasonText };
